import { OTEL_META_TAG_NAME } from '../constants'

export function getInjectedOtelToken() {
  return (
    document.querySelector(`meta[name="${OTEL_META_TAG_NAME}"]`)?.getAttribute('content') ?? null
  )
}
